<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-inputnumber [(ngModel)]="value" [useGrouping]="false" [showButtons]="true" size="small" mode="decimal"
      inputId="withoutgrouping" class="w-full" appendTo="body" [ngClass]="recovery ? 'recover-data' : ''"
      [disabled]="disabled" autocomplete="off" (onBlur)="changeNumber($event)" (onFocus)="selectAllText($event)" />
  </div>
</ng-container>